import { defineNuxtPlugin } from '#app/nuxt'
import { LazyBackgroundPattern, LazyBlurImageBackground, LazyBottomPanel, LazyCalendarCard, LazyCarousel, LazyCarouselSkeleton, LazyCategoryList, LazyCheckList, LazyColumnCard, LazyColumnEventCard, LazyColumnNewsCard, LazyColumnNewsCardSkeleton, LazyContent, LazyContentSection, LazyDatePicker, LazyDatePickerDialog, LazyDisclosure, LazyDropdown, LazyDynamicDateTabList, LazyEpisodeList, LazyErrorList, LazyEventCard, LazyEventCover, LazyEventList, LazyEventListLayoutA, LazyEventListLayoutB, LazyFooter, LazyFormCheckbox, LazyFormInput, LazyFormTextarea, LazyHST, LazyHomeEpisodeCarousel, LazyHomeNavigation, LazyHorizontalScrollingText, LazyIcon, LazyLinkList, LazyLocaleSwitcher, LazyMap, LazyModal, LazyNavBottom, LazyNavbar, LazyNavbarRadioBar, LazyNavbarSearchPanel, LazyNewsList, LazyNewsListLayoutA, LazyNewsListLayoutASkeleton, LazyNewsListLayoutB, LazyNewsListLayoutBSkeleton, LazyNewsletterSection, LazyPageLayout, LazyPagination, LazyPartnersPagesGrid, LazyPlayer, LazyPlayerControls, LazyPlayerCover, LazyPlayerLiveDot, LazyPlayerMainTitle, LazyPlayerPanel, LazyPlayerProgressBar, LazyPlayerSecondTitle, LazyPlayerSmall, LazyPlayerSmallDesktop, LazyPlayerSmallMobile, LazyPlayerTime, LazyPlayerTimeline, LazyPodcastCarousel, LazyPrimaryBadge, LazyPrimaryButton, LazyProgramCard, LazyProgramCardSkeleton, LazyProgramList, LazyRSSFeedButton, LazyRadioEpisodeCarousel, LazyRadioFilter, LazyRadioProgramCarousel, LazyRadioTabsPanel, LazyRoundedImage, LazyRowCard, LazyRowEventCard, LazyRowNewsCard, LazyRowNewsCardSkeleton, LazyScheduleList, LazyScheduleWeekView, LazySearchAccordion, LazySearchbar, LazySecondaryBadge, LazySecondaryButton, LazySelect, LazySideMenu, LazySidePanel, LazySidebar, LazySlider, LazySliderCard, LazySliderSkeleton, LazySocialNetworkList, LazySongCard, LazySponsorCard, LazySquareButton, LazyStaticPageRenderer, LazyTabs, LazyThemeCard, LazyTimePicker, LazyTimePickerDialog, LazyToast, LazyToaster, LazyTruncatedText, LazyVolumeBar, LazyVolumeControl, LazyWhatSongModule, LazyWhatWouldLikeListenSection, LazyEmbeddedEpisodeCard, LazyEmbeddedListenLive, LazyEmbeddedModal, LazyEmbeddedProgramCard, LazyContentDoc, LazyContentList, LazyContentNavigation, LazyContentQuery, LazyContentRenderer, LazyContentRendererMarkdown, LazyContentSlot, LazyDocumentDrivenEmpty, LazyDocumentDrivenNotFound, LazyMarkdown, LazyProseA, LazyProseBlockquote, LazyProseCode, LazyProseCodeInline, LazyProseEm, LazyProseH1, LazyProseH2, LazyProseH3, LazyProseH4, LazyProseH5, LazyProseH6, LazyProseHr, LazyProseImg, LazyProseLi, LazyProseOl, LazyProseP, LazyProseStrong, LazyProseTable, LazyProseTbody, LazyProseTd, LazyProseTh, LazyProseThead, LazyProseTr, LazyProseUl } from '#components'
const lazyGlobalComponents = [
  ["BackgroundPattern", LazyBackgroundPattern],
["BlurImageBackground", LazyBlurImageBackground],
["BottomPanel", LazyBottomPanel],
["CalendarCard", LazyCalendarCard],
["Carousel", LazyCarousel],
["CarouselSkeleton", LazyCarouselSkeleton],
["CategoryList", LazyCategoryList],
["CheckList", LazyCheckList],
["ColumnCard", LazyColumnCard],
["ColumnEventCard", LazyColumnEventCard],
["ColumnNewsCard", LazyColumnNewsCard],
["ColumnNewsCardSkeleton", LazyColumnNewsCardSkeleton],
["Content", LazyContent],
["ContentSection", LazyContentSection],
["DatePicker", LazyDatePicker],
["DatePickerDialog", LazyDatePickerDialog],
["Disclosure", LazyDisclosure],
["Dropdown", LazyDropdown],
["DynamicDateTabList", LazyDynamicDateTabList],
["EpisodeList", LazyEpisodeList],
["ErrorList", LazyErrorList],
["EventCard", LazyEventCard],
["EventCover", LazyEventCover],
["EventList", LazyEventList],
["EventListLayoutA", LazyEventListLayoutA],
["EventListLayoutB", LazyEventListLayoutB],
["Footer", LazyFooter],
["FormCheckbox", LazyFormCheckbox],
["FormInput", LazyFormInput],
["FormTextarea", LazyFormTextarea],
["HST", LazyHST],
["HomeEpisodeCarousel", LazyHomeEpisodeCarousel],
["HomeNavigation", LazyHomeNavigation],
["HorizontalScrollingText", LazyHorizontalScrollingText],
["Icon", LazyIcon],
["LinkList", LazyLinkList],
["LocaleSwitcher", LazyLocaleSwitcher],
["Map", LazyMap],
["Modal", LazyModal],
["NavBottom", LazyNavBottom],
["Navbar", LazyNavbar],
["NavbarRadioBar", LazyNavbarRadioBar],
["NavbarSearchPanel", LazyNavbarSearchPanel],
["NewsList", LazyNewsList],
["NewsListLayoutA", LazyNewsListLayoutA],
["NewsListLayoutASkeleton", LazyNewsListLayoutASkeleton],
["NewsListLayoutB", LazyNewsListLayoutB],
["NewsListLayoutBSkeleton", LazyNewsListLayoutBSkeleton],
["NewsletterSection", LazyNewsletterSection],
["PageLayout", LazyPageLayout],
["Pagination", LazyPagination],
["PartnersPagesGrid", LazyPartnersPagesGrid],
["Player", LazyPlayer],
["PlayerControls", LazyPlayerControls],
["PlayerCover", LazyPlayerCover],
["PlayerLiveDot", LazyPlayerLiveDot],
["PlayerMainTitle", LazyPlayerMainTitle],
["PlayerPanel", LazyPlayerPanel],
["PlayerProgressBar", LazyPlayerProgressBar],
["PlayerSecondTitle", LazyPlayerSecondTitle],
["PlayerSmall", LazyPlayerSmall],
["PlayerSmallDesktop", LazyPlayerSmallDesktop],
["PlayerSmallMobile", LazyPlayerSmallMobile],
["PlayerTime", LazyPlayerTime],
["PlayerTimeline", LazyPlayerTimeline],
["PodcastCarousel", LazyPodcastCarousel],
["PrimaryBadge", LazyPrimaryBadge],
["PrimaryButton", LazyPrimaryButton],
["ProgramCard", LazyProgramCard],
["ProgramCardSkeleton", LazyProgramCardSkeleton],
["ProgramList", LazyProgramList],
["RSSFeedButton", LazyRSSFeedButton],
["RadioEpisodeCarousel", LazyRadioEpisodeCarousel],
["RadioFilter", LazyRadioFilter],
["RadioProgramCarousel", LazyRadioProgramCarousel],
["RadioTabsPanel", LazyRadioTabsPanel],
["RoundedImage", LazyRoundedImage],
["RowCard", LazyRowCard],
["RowEventCard", LazyRowEventCard],
["RowNewsCard", LazyRowNewsCard],
["RowNewsCardSkeleton", LazyRowNewsCardSkeleton],
["ScheduleList", LazyScheduleList],
["ScheduleWeekView", LazyScheduleWeekView],
["SearchAccordion", LazySearchAccordion],
["Searchbar", LazySearchbar],
["SecondaryBadge", LazySecondaryBadge],
["SecondaryButton", LazySecondaryButton],
["Select", LazySelect],
["SideMenu", LazySideMenu],
["SidePanel", LazySidePanel],
["Sidebar", LazySidebar],
["Slider", LazySlider],
["SliderCard", LazySliderCard],
["SliderSkeleton", LazySliderSkeleton],
["SocialNetworkList", LazySocialNetworkList],
["SongCard", LazySongCard],
["SponsorCard", LazySponsorCard],
["SquareButton", LazySquareButton],
["StaticPageRenderer", LazyStaticPageRenderer],
["Tabs", LazyTabs],
["ThemeCard", LazyThemeCard],
["TimePicker", LazyTimePicker],
["TimePickerDialog", LazyTimePickerDialog],
["Toast", LazyToast],
["Toaster", LazyToaster],
["TruncatedText", LazyTruncatedText],
["VolumeBar", LazyVolumeBar],
["VolumeControl", LazyVolumeControl],
["WhatSongModule", LazyWhatSongModule],
["WhatWouldLikeListenSection", LazyWhatWouldLikeListenSection],
["EmbeddedEpisodeCard", LazyEmbeddedEpisodeCard],
["EmbeddedListenLive", LazyEmbeddedListenLive],
["EmbeddedModal", LazyEmbeddedModal],
["EmbeddedProgramCard", LazyEmbeddedProgramCard],
["ContentDoc", LazyContentDoc],
["ContentList", LazyContentList],
["ContentNavigation", LazyContentNavigation],
["ContentQuery", LazyContentQuery],
["ContentRenderer", LazyContentRenderer],
["ContentRendererMarkdown", LazyContentRendererMarkdown],
["ContentSlot", LazyContentSlot],
["DocumentDrivenEmpty", LazyDocumentDrivenEmpty],
["DocumentDrivenNotFound", LazyDocumentDrivenNotFound],
["Markdown", LazyMarkdown],
["ProseA", LazyProseA],
["ProseBlockquote", LazyProseBlockquote],
["ProseCode", LazyProseCode],
["ProseCodeInline", LazyProseCodeInline],
["ProseEm", LazyProseEm],
["ProseH1", LazyProseH1],
["ProseH2", LazyProseH2],
["ProseH3", LazyProseH3],
["ProseH4", LazyProseH4],
["ProseH5", LazyProseH5],
["ProseH6", LazyProseH6],
["ProseHr", LazyProseHr],
["ProseImg", LazyProseImg],
["ProseLi", LazyProseLi],
["ProseOl", LazyProseOl],
["ProseP", LazyProseP],
["ProseStrong", LazyProseStrong],
["ProseTable", LazyProseTable],
["ProseTbody", LazyProseTbody],
["ProseTd", LazyProseTd],
["ProseTh", LazyProseTh],
["ProseThead", LazyProseThead],
["ProseTr", LazyProseTr],
["ProseUl", LazyProseUl]
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
